const initialState = {
    Data: []
  };
  
  const TeamsConfigReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case "GET_TEAMCONFIG_INFO":
        return {
          ...state,
          Data: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default TeamsConfigReducer;